// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import VueLocalStorage from 'vue-ls'
import ViewSystem from './components/steps/ViewSystem'
import ConfigureSystem from './components/steps/ConfigureSystem'
import SelectRemote from './components/steps/SelectRemote'
import ContactInfo from './components/steps/ContactInfo'
import ContactDealer from './components/steps/ContactDealer'
import ThankYou from './components/steps/ThankYou'
import DealerFollowup from './components/steps/DealerFollowup'
import DealerFollowupComplete from './components/steps/DealerFollowupComplete'
import $ from 'jquery'

Vue.config.productionTip = false
Vue.config.devtools = false

Vue.use(VueLocalStorage)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App, ConfigureSystem, SelectRemote, ViewSystem, ContactInfo, ContactDealer, DealerFollowup, DealerFollowupComplete, ThankYou}
})

// Fix window height issue
$('#root').css('display', 'inline')



// WEBPACK FOOTER //
// ./src/main.js